import { createReducer } from '@reduxjs/toolkit'
import { preloadedState } from '../../appState'
import { setShop, setShopReducer } from './setShopReducer'

const shopReducers = createReducer(preloadedState.shop, builder => {
  builder.addCase(setShop.type, setShopReducer)
})

export default shopReducers
